module.exports = __webpack_public_path__ + "img/ez-theme-switcher-bg.f8595565.f8595565.jpg";